import { Component, OnInit, ViewChild, Injector, signal, computed, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { GetRenewalNonmotorDetailService } from '../../adapters/getRenewalNonmotorDetail.service';
import { GetMaskingService } from '../../adapters/getMasking.service';
import { environment } from '../../../environments/environment';
import { FormsModule, NgForm } from '@angular/forms';
import { default as theme } from '../renewal-theme.json';
import { SendLineMessageService } from 'src/app/adapters/sendLineMessage.service';
import { ConstantsService } from '../../shared/service/constants/constants.service'
import { CalculateInstallmentNonmotor } from '../../adapters/calculateInstallmentNonmotor.service'
import { GetAllLocationService } from 'src/app/adapters/getAllLocation.service';
import { GetCompanyUCIDService } from 'src/app/adapters/getCompanyUCID.service';
import { UpdateRenewNonmotorLetterInstallment } from '../../adapters/updateRenewNonmotorLetterInstallment.service'
import { UpdateRenewNonmotorDetailService } from '../../adapters/updateRenewNonmotorDetail.service';
import { formatDate } from '@angular/common';
import { CallTss } from 'src/app/adapters/callTss.service';
import { BaseComponents } from '../../base.component';
import { GetNonMotorPaymentSummary } from 'src/app/adapters/getNonMotorPaymentSummary.service';
import { GetLineTokenService } from 'src/app/adapters/getLineToken.service';
import * as uuid from 'uuid';
import liff from '@line/liff';
declare var window: any;

@Component({
  selector: 'app-nonmotor-step',
  templateUrl: './nonmotor-step.component.html',
  styleUrls: ['./nonmotor-step.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone:false
})
export class NonMotorStepComponent extends BaseComponents implements OnInit {
  @ViewChild('renewForm') renewForm: NgForm;

  insuredetail_data: any;
  insuredetail_data_temp: any;
  dataucid: any;
  comcode: string;
  line_id: string;
  liff_id: string;
  rm_channelId: string;
  electronic_channel: string;
  loader = signal<boolean>(false);
  style: any = {};
  product_type: number

  form_first = signal<boolean>(true);
  form_second = signal<boolean>(false);
  form_third =  signal<boolean>(false);
  form_fourth = signal<boolean>(false);

  months: any = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];

  profile: any

  total_amount = signal<number>(0.0);
  monthly_premium = signal<number>(0.0);
  first_month = signal<number>(0.0);
  
  first_month_total = computed(() => this.first_month() + this.monthly_premium() * 2)

  //form_first
  main_insurance: Array<any>
  check_all_main = signal<boolean>(true);
  has_checked = signal<boolean>(true);

  //form_second
  second_insurance: Array<any>
  check_all_second = signal<boolean>(false);

  // form_third
  checkBoxFullPay = signal<boolean>(true);
  checkBokInstallment = signal<boolean>(false);
  dataLoadInstallment: any;
  installmentData = signal<any>(null);
  installmentStatus = signal<boolean>(false);

  // form_fourth
  addrValue1: any;
  addrValue2: any;
  addrValue3: any;
  addrValue4: any;
  phoneValue: any;
  editAddr = signal<boolean>(false);
  editTel = signal<boolean>(false);
  companyId: any;
  f09Status: number;
  additional_text: string;
  not_additional_text: string;

  subDistrict : any;
  district : any;
  province : any;

  keyword = 'text';
  // access_token_line: string = "";
  logger_text: string = `nonmotor-step ${uuid.v4()} =>`
  liff_channel_id: string = "";
  channel_line_id: string = "";
  subChannel: number | null = null;
  constructor(
    protected injectorObj: Injector,
    private getRenewalNonmotorDetailService: GetRenewalNonmotorDetailService,
    private getMaskingService : GetMaskingService,
    private route: ActivatedRoute,
    private router: Router,
    private SendLineMessage: SendLineMessageService,
    private ConstantsService: ConstantsService,
    private calculateInstallmentNonmotor: CalculateInstallmentNonmotor,
    private getAllLocationService: GetAllLocationService,
    private getCompanyUCIDService: GetCompanyUCIDService,
    private updateRenewNonmotorLetterInstallment: UpdateRenewNonmotorLetterInstallment,
    private updateRenewNonmotorDetailService: UpdateRenewNonmotorDetailService,
    private callTss: CallTss,
    private getNonMotorPaymentSummary: GetNonMotorPaymentSummary,    
    private getLineTokenService: GetLineTokenService
  ) {
    super(injectorObj);
    this.insuredetail_data = {
      product_family_flag: null,
      refNo: "",
      payment_amount: null,
      main_protection: [],
      second_protection: [],
    }
    // Create temp
    this.insuredetail_data_temp = {
      additionalProduct: [],
      address: "",
      carBrand: "",
      carNo: "",
      carProvince: null,
      carUsage: null,
      carYear: null,
      claim: [],
      decoration: [],
      installment: [],
      insuredName: "",
      lastClaimDate: "",
      name: "",
      oldExpireDate: "",
      oldInsureModel: "",
      oldInsureNo: "",
      oldInsureType: null,
      phoneNo: "",
      nameOfferInsureBrand: "",
      offerInsureAmount: 0,
      offerInsureFund: 0,
      offerInsureClaim: "",
      protection1: 0,
      protection2: 0,
      protection3: 0,
      protection4: 0,
      protection5: 0,
      protection6: 0,
      protection7: 0,
      protection8: 0,
      protection9: 0,
      protection10: 0,
      protection11: 0,
      protection12: 0,
      refNo: "",
      refNo2: "", //use in first form
      totalamount: 0,
      insuranceType: "",
      product_type: null,
      instTerm: 0,
      instFirstDate: "",
      logoOfferInsureBrand: "",
      fixOffer: "",
      otherProductImage: "",
      item2936_16211: ""
    }
    this.dataLoadInstallment = {
      response_code: "",
      data: []
    }
  }

  async ngOnInit() {
    await this.route.queryParams.subscribe(params => {
      this.dataucid = params['dataucid'];
      this.liff_id = params['appRef'];
      this.rm_channelId = params['rm_channelId'];
      this.electronic_channel = params['electronic_channel'];
      this.comcode = params['comcode'];
      this.style = theme[this.comcode];
      this.product_type = params['product_type'];
      this.liff_channel_id = params['liff_channel_id'];
      this.channel_line_id = params['channel_line_id'];
      this.subChannel = params['subchannel'] ? parseInt(params['subchannel']) : null;
      this.logger.info('params nonmotor :', params)      

      // this.liff_id = '1653923162-wJQEqrYj';      
    });

    try {
      // const profile = await liff.getProfile();
      // this.line_id = profile.userId;
      this.getData(this.dataucid);
      // await liff.init({ liffId: this.liff_id})
      //   if(liff.isLoggedIn() === false && liff.isInClient() === false){
      //     this.logger.info([this.logger_text,'login liff callback path:', window.location.href]);
      //     liff.login({ redirectUri: window.location.href })
      //   }else{
      //     this.access_token_line = await liff.getAccessToken();
      //     this.logger.debug([this.logger_text,'access_token_line:', this.access_token_line]);
      //     this.getData(this.dataucid);
      //     // const profile = await liff.getProfile();
      //     // this.line_id = profile.userId;   
      //   }        
    } catch(error) {
      this.logger.error([this.logger_text,'error get login liff :', error.message]);
      if (error.code === '401' || error?.message === "The access token expired" || error?.message === "Load failed" || error?.message === "access_token is required") {
        this.logger.error([this.logger_text,'error line_token nonmotor-step :', error?.message]);
        liff.logout()
        liff.login({ redirectUri: window.location.href })
        } else {
          this.logger.error(`${this.logger_text} error nonmotor-step  ${error?.message}`);
          this.router.navigate(['/renewal/page-error']);
        }
      // this.line_id = 'Udadc4f8639df4d33a48f95ae5024fb57';
    }
  }

  getData(dataucid: any) {
    this.getRenewalNonmotorDetailService.exec({ dataucid: dataucid }).then((res: any) => {
      this.insuredetail_data = res.data.obj;
      this.insuredetail_data_temp = JSON.parse(JSON.stringify(res.data.obj));
      this.main_insurance = this.insuredetail_data.main_protection
      this.second_insurance = this.insuredetail_data.second_protection
      this.loader.set(true);
      this.getCompanyUCIDService.exec({}).then((res: any) => {
        this.companyId = res.data ? res.data._1 : ''
      })
      this.setCheckedInsurance('all')
      this.logger.debug(this.insuredetail_data)
    }).catch((error) => {
      this.logger.error([this.logger_text,'error getRenewalNonmotorDetailService :', error?.message]);
      if (error.code === '401' || error?.message === "The access token expired" || error?.message === "Load failed" || error?.message === "access_token is required") {
        this.logger.error([this.logger_text,'error line_token nonmotor-step :', error?.message]);
        liff.logout()
        liff.login({ redirectUri: window.location.href })
        } else {
          this.logger.error(`${this.logger_text} error nonmotor-step  ${error?.message}`);
          this.router.navigate(['/renewal/page-error']);
        }
    });
  }

  numberWithCommas(x) {
    const fixedNumber = x.toFixed(2);
    return String(fixedNumber).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  setCheckedInsurance(page) {
    if (page === 'all' || page === 'main') {
      if (this.check_all_main() == true) {
        for (let i = 0; i < this.main_insurance.length; ++i) {
          for (let j = 0; j < this.main_insurance[i].length; ++j) {
            this.main_insurance[i][j].checked = true
          }
        }
      } else {
        for (let i = 0; i < this.main_insurance.length; ++i) {
          for (let j = 0; j < this.main_insurance[i].length; ++j) {
            this.main_insurance[i][j].checked = false
          }
        }
      }
    }
    if (this.second_insurance && (page === 'all' || page === 'second')) {
      if (this.check_all_second() == true) {
        for (let i = 0; i < this.second_insurance.length; ++i) {
          for (let j = 0; j < this.second_insurance[i].length; ++j) {
            this.second_insurance[i][j].checked = true
          }
        }
      } else {
        for (let i = 0; i < this.second_insurance.length; ++i) {
          for (let j = 0; j < this.second_insurance[i].length; ++j) {
            this.second_insurance[i][j].checked = false
          }
        }
      }
    }
    this.calculateTotalPrice()
  }

  clickAdditionalOption(i: number, j: number, page: string) {
    if (page === 'main') {
      if (this.main_insurance[i][j].checked == true) {
        this.main_insurance[i][j].checked = false
      } else {
        this.main_insurance[i][j].checked = true
      }
      this.setHasChecked()
    }
    if (page === 'second') {
      if (this.second_insurance[i][j].checked == true) {
        this.second_insurance[i][j].checked = false
      } else {
        this.second_insurance[i][j].checked = true
      }
    }
    this.setCheckAllSelect(page)
    this.calculateTotalPrice()
  }

  clickCheckAll(page) {
    if (page === 'main') {
      if (this.check_all_main() == true) {
        this.check_all_main.set(false);
        this.has_checked.set(false)
      } else {
        this.check_all_main.set(true)
        this.has_checked.set(true)
      }
    }
    if (page === 'second') {
      if (this.check_all_second() == true) {
        this.check_all_second.set(false)
      } else {
        this.check_all_second.set(true)
      }
    }
    this.setCheckedInsurance(page)
  }

  calculateTotalPrice() {
    this.total_amount.set(0)
    this.monthly_premium.set(0)
    this.first_month.set(0)
    for (let i = 0; i < this.main_insurance.length; ++i) {
      for (let j = 0; j < this.main_insurance[i].length; ++j) {
        if (this.main_insurance[i][j].checked == true) {
          this.total_amount.update(x => x + this.main_insurance[i][j].premium)
          this.monthly_premium.update(x => x + this.main_insurance[i][j].monthly_premium);
          if (this.main_insurance[i][j].monthly_premium == 0 || this.main_insurance[i][j].monthly_premium == null) {
            this.first_month.update(x => x + parseFloat(this.main_insurance[i][j].premium));
          }
        }
      }
    }
    if (this.second_insurance) {
      for (let i = 0; i < this.second_insurance.length; ++i) {
        for (let j = 0; j < this.second_insurance[i].length; ++j) {
          if (this.second_insurance[i][j].checked == true) {
            this.total_amount.update(x => x + this.second_insurance[i][j].premium);
            this.monthly_premium.update(x => x + this.second_insurance[i][j].monthly_premium)
            if (this.second_insurance[i][j].monthly_premium == 0 || this.second_insurance[i][j].monthly_premium == null) {
              this.first_month.update(x => x + parseFloat(this.second_insurance[i][j].premium));
            }
          }
        }
      }
    }
  }

  calculateTotalPricePerPerson(i) {
    let sum = 0;
    let sum_main = 0;
    let sum_second = 0;

    for (let j = 0; j < this.main_insurance[i].length; ++j) {
      if (this.main_insurance[i][j].checked == true) {
        sum_main += this.main_insurance[i][j].premium
      }
    }
    if (this.second_insurance[i]) {
      for (let j = 0; j < this.second_insurance[i].length; ++j) {
        if (this.second_insurance[i][j].checked == true) {
          sum_second += this.second_insurance[i][j].premium
        }
      }
    }
    sum = sum_main + sum_second
    const fixedNumber = sum.toFixed(2);
    return fixedNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  setCheckAllSelect(page) {
    if (page === 'main') {
      this.check_all_main.set(true);
      for (let i = 0; i < this.main_insurance.length; ++i) {
        for (let j = 0; j < this.main_insurance[i].length; ++j) {
          if (this.main_insurance[i][j].checked == false) {
            this.check_all_main.set(false);
            return false;
          }
        }
      }
    }
    if (this.second_insurance && page === 'second') {
      this.check_all_second.set(true);
      for (let i = 0; i < this.second_insurance.length; ++i) {
        for (let j = 0; j < this.second_insurance[i].length; ++j) {
          if (this.second_insurance[i][j].checked == false) {
            this.check_all_second.set(false);
            return false;
          }
        }
      }
    }
  }

  setHasChecked() {
    this.has_checked.set(false);
    for (let i = 0; i < this.main_insurance.length; ++i) {
      for (let j = 0; j < this.main_insurance[i].length; ++j) {
        if (this.main_insurance[i][j].checked == true) {
          this.has_checked.set(true);
          return false;
        }
      }
    }
  }

  onNextStep(step) {
    this.form_first.set(false);
    this.form_second.set(false);
    this.form_third.set(false);
    this.form_fourth.set(false);
    if (step === 'toFirst') {
      this.form_first.set(true);
    }
    if (step === 'toSecond') {
      this.form_second.set(true);
    }
    if (step === 'toThird') {
      this.form_third.set(true);
      this.onLoadInstallment()
    }
    if (step === 'toFourth') {
      this.form_fourth.set(true);
    }
  }

  onClickFullPay() {
    if (this.checkBoxFullPay() == true) {
      this.checkBoxFullPay.set(false)
      this.checkBokInstallment.set(true)
    }
    else {
      this.checkBoxFullPay.set(true)
      this.checkBokInstallment.set(false)
    }
  }

  onClickInstallment() {
    if (this.checkBokInstallment() == true) {
      this.checkBoxFullPay.set(true)
      this.checkBokInstallment.set(false)
    }
    else {
      this.checkBoxFullPay.set(false)
      this.checkBokInstallment.set(true)
    }
  }

  async onLoadInstallment() {
    this.additional_text = ""
    this.not_additional_text = ""
    for (let i = 0; i < this.main_insurance.length; ++i) {
      this.insuredetail_data.main_protection[i].map(list => {
        if (list.checked == true) {
          this.additional_text += list.letter_ucid + ","
        } else {
          this.not_additional_text += list.letter_ucid + ","
        }
      })
    }
    if (this.second_insurance) {
      for (let i = 0; i < this.second_insurance.length; ++i) {
        this.insuredetail_data.second_protection[i].map(list => {
          if (list.checked == true) {
            this.additional_text += list.letter_ucid + ","
          } else {
            this.not_additional_text += list.letter_ucid + ","
          }
        })
      }
    }

    this.dataLoadInstallment = await this.calculateInstallmentNonmotor.exec({
      "data_ucid": this.dataucid,
      "payment_flag": 2,
      "list_of_letter_ucid_selected": this.additional_text
    })  
    if (this.dataLoadInstallment.response_code == "40000") {
      this.installmentData.set(this.dataLoadInstallment.data)
      this.installmentStatus.set(false);
      if (this.installmentData()?.length > 1) {
        this.installmentStatus.set(true);
      }
    } else {
      this.installmentStatus.set(false);
    }
  }

  convertDateThai(input_date) {
    let months: any = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];
    let date_result = new Date(input_date)
    return `${date_result.getDate()} ${months[date_result.getMonth()]} ${date_result.getFullYear() + 543}`
  }

  // form_fourth
  model: any = {
    address: {
      current: {
        subDistrict: '',
        subDistrictText: '',
        district: '',
        districtText: '',
        province: '',
        provinceText: '',
        postCode: '',
        postCodeText: ''
      }
    }
  }
  results: any = {};
  timeout: any = {};
  search: string = '';
  isLoading: any = {};
  regZipCode = /^[0-9]{5}\d*$/

  public addClass(f: NgForm, field: string, type?: string, valueActive = '') {
    let iClass = [];
    if (f.form.controls[field] && type !== 'msg') {
      if (f.form.controls[field].invalid && (f.form.controls[field].dirty || f.form.controls[field].touched || f.submitted)) {
        iClass.push('uk-form-danger')
      } else if (f.form.controls[field].valid && (f.form.controls[field].dirty || f.form.controls[field].touched || f.submitted)) {
        if (valueActive === "") {
          iClass.push('uk-form-success')
        } else if (f.form.controls[field].value == valueActive) {
          iClass.push('uk-form-success')
        }
      }
    } else if (f.form.controls[field] && type == 'msg') {
      if (f.form.controls[field].invalid && (f.form.controls[field].dirty || f.form.controls[field].touched || f.submitted)) {
        iClass.push('uk-animation-fade')
      } else if (f.form.controls[field].valid && (f.form.controls[field].dirty || f.form.controls[field].touched || f.submitted)) {
        iClass.push('uk-animation-reverse')
      }
    }
    return iClass
  }

  onChangeSearch2(search: string, type: string, mode: string = 'current') {
    if (this.timeout[type]) {
      clearTimeout(this.timeout[type]);
    }
    this.timeout[type] = setTimeout(() => {
      this.searchData(search, type, mode);
    }, 1);
  }

  searchData(search: string, type: string, mode: string = 'current') {

    this.isLoading[mode + '.' + type] = true;    
    let body = {
      "companyID": this.companyId,
      "subDistrict": type == "subDistrict" ? search : '',
      "district": type == "district" ? search : '',
      "province": type == "province" ? search : '',
      "postCode": type == "postCode" ? search : ''
    }

    this.getAllLocationService.exec(body).then((res: any) => {
      this.isLoading[mode + '.' + type] = false;
      this.results[mode + '.' + type] = res.map((repo: any) => {
        let subDistrict: any = repo.subDistrict;
        let district: any = repo.district;
        let province: any = repo.province;
        let postCode: any = repo.postCode;
        let value: any = '';
        if (type == "subDistrict") {
          subDistrict = `<b>${subDistrict}</b>`;
          value = repo.subDistrict;
        } else if (type == "district") {
          district = `<b>${district}</b>`;
          value = repo.district;
        } else if (type == "province") {
          province = `<b>${province}</b>`;
          value = repo.province;
        } else if (type == "postCode") {
          postCode = `<b>${postCode}</b>`;
          value = repo.postCode;
        }
        let markup: any = [subDistrict, district, province, postCode].join(" >> ");        
        let test = {
          text: repo[type],
          markup: markup,
          value: value,
          data: repo
        }; 
        return {
          text: repo[type],
          markup: markup,
          value: value,
          data: repo
        };
      });
    }).catch((err) => {
      this.logger.error("get location: ", err)
      this.isLoading[mode + '.' + type] = false;
      this.results = [];
    });
  }

  onSelect2(item: any, type: string, mode: string = 'current') {
    if (item.data) {
      this.subDistrict = item.data.subDistrict;
      this.district = item.data.district;
      this.province = item.data.province;
      this.model.address[mode].subDistrict = item.data.subDistrict;
      this.model.address[mode].subDistrictText = item.data.subDistrict;
      this.model.address[mode].district = item.data.district;
      this.model.address[mode].districtText = item.data.district;
      this.model.address[mode].province = item.data.province;
      this.model.address[mode].provinceText = item.data.province;
      this.model.address[mode].postCode = item.data.postCode;
    } else {
      let arr = ['subDistrict', 'subDistrictText', 'district', 'districtText', 'province', 'provinceText', 'postCode', 'zipCode'];
      arr.map(val => {
        if (val != type + 'Text') {
          this.model.address[mode][val] = null;
        }
      });
    }
  }
  onFocused(e){
    // do something when input is focused
  }
  onClearSelect(){
    this.subDistrict = null;
    this.district = null;
    this.province = null;

    this.model.address.current.subDistrict = null;
    this.model.address.current.subDistrictText = null;
    this.model.address.current.district = null;
    this.model.address.current.districtText = null;
    this.model.address.current.province = null;
    this.model.address.current.provinceText = null;
    this.model.address.current.postCode = null;
    this.model.address.current.zipCode = null;
}

  onEditAddr() {
    this.editAddr.set(true);
    this.addrValue1 = "";
    this.model.address.current.subDistrictText = "";
    this.model.address.current.districtText = "";
    this.model.address.current.provinceText = "";
    this.model.address.current.postCode = "";
  }

  onEditTel() {
    this.editTel.set(true);
    this.phoneValue = this.insuredetail_data.phoneNo;
  }

  onInputAddr1(e) {
    this.addrValue1 = e.target.value;
  }

  onInputAddr2(e) {
    this.addrValue2 = e.target.value;
  }

  onInputAddr3(e) {
    for (let i = 0; i < this.insuredetail_data.province.length; i++) {
      if (e.target.value == this.insuredetail_data.province[i].value) {
        this.addrValue3 = this.insuredetail_data.province[i].detail;
        break;
      }
    }
  }

  onInputAddr4(e) {
    this.addrValue4 = e.target.value;
  }

  onInputPhone(e) {
    this.phoneValue = e.target.value;
  }

  onSaveTel() {
    this.editTel.set(false);
    this.insuredetail_data.phoneNo =  this.phoneValue;
    this.logger.debug(this.insuredetail_data.phoneNo)
  }

  onCancelEditTel() {
    this.editTel.set(false);
  }

  onCancelEditAddr() {
    this.editAddr.set(false);
  }

  onSaveAddr(f: NgForm) {
    // เขต
    const address = this.addrValue1
    const subDistrict = this.model.address.current.subDistrictText
    const district = this.model.address.current.districtText
    const province = this.model.address.current.provinceText
    const postCode = this.model.address.current.postCode
    const isValidate = this.onValiadteAddress(f)
    if (isValidate) {
      this.insuredetail_data.address = `${address} ${subDistrict} ${district} ${province} ${postCode}`
      this.editAddr.set(false);
      this.resetModelAddress()
    }
  }

  resetModelAddress() {
    this.model = {
      address: {
        current: {
          subDistrict: '',
          subDistrictText: '',
          district: '',
          districtText: '',
          province: '',
          provinceText: '',
          postCode: '',
          postCodeText: ''
        }
      }
    }
    this.addrValue1 = ''
  }

  onValiadteAddress(f: NgForm) {
    f.form.markAsTouched()
    if (f.form.valid) {
      return true
    }
    return false
  }

  async onSubmit() {
    this.loader.set(false)
    this.f09Status = 42
    let body = this.createBodyUpdateRenew()
    this.logger.debug('createBodyUpdateRenew Nonmotor', body)
    const responseUpdateRenew = await this.updateRenewNonmotorDetailService.exec(body, '')
    this.logger.debug('responseUpdateRenew Nonmotor', responseUpdateRenew)

    this.logger.debug('letter_ucid_selected: ', this.additional_text)
    this.logger.debug('letter_ucid_not_selected: ', this.not_additional_text)

    const responseUpdateLetter = await this.updateRenewNonmotorLetterInstallment.exec({
      "data_ucid": this.dataucid,
      "list_of_letter_ucid_selected": this.additional_text,
      "list_of_letter_ucid_not_selected": this.not_additional_text
    })
    this.logger.debug('responseUpdateLetter', responseUpdateLetter)

    const responseGetPaymentSummary = await this.getNonMotorPaymentSummary.exec({ dataucid: this.dataucid});
    this.logger.debug('response get payment summary', responseGetPaymentSummary);

    const prepareTSS = this.populatePrepareData(responseGetPaymentSummary, body.payment_method)
    await this.callTssService(prepareTSS)
    this.logger.debug('prepareTSS', prepareTSS)

    if (this.f09Status == this.ConstantsService.updateRenewNonmotorTssSuccess || this.f09Status == this.ConstantsService.updateRenewNonmotorTssFail) {
      let body = this.createBodyUpdateRenew();
      this.logger.debug('createBodyUpdateRenew', body);
      const responseUpdateRenew = await this.updateRenewNonmotorDetailService.exec(body, '');
      this.logger.debug('responseUpdateRenew', responseUpdateRenew);
      if (responseUpdateRenew['status']) {
        this.flexSummaryTemplate();
      } else {
        this.logger.debug('error responseUpdateRenew', responseUpdateRenew);
      }
    }
  }

  callTssService(bodyTss): Promise<any> {
    this.f09Status = this.ConstantsService.updateRenewNonmotorTssFail
    return this.callTss.exec(bodyTss).then((res: any) => {
      this.logger.debug('callTssService res', res)
      if (res.response_code === '40000') {
        this.f09Status = this.ConstantsService.updateRenewNonmotorTssSuccess
        return { status: true, data: res }
      } else {
        return { status: false, data: res }
      }
    }).catch((e) => {
      return { status: false, data: e }
    })
  }

  populatePrepareData = (paymentSummary, paymentMethod: string) => {
    const prepareData = {
      "app_code": this.insuredetail_data.appCode,
      "account_no": this.insuredetail_data.accountNo,
      "lead_date": formatDate(this.insuredetail_data.leadDate, 'dd/MM/yyyy', 'en-US'),
      "client_no": this.insuredetail_data.clientNo,
      "classify_insure": '2',
      "f09_update_inform": '40',
      "address_old": this.insuredetail_data_temp.address,
      "address": this.insuredetail_data.address,
      "mobile_no_old": this.insuredetail_data_temp.phoneNo,
      "mobile_no": this.insuredetail_data.phoneNo,
      "agent1": this.insuredetail_data.agent1,
      "agent2": this.insuredetail_data.agent2,
      "payment_summary": paymentSummary.data ? paymentSummary.data : "",
      "payment_method": paymentMethod
    }
    return prepareData
  }

  createBodyUpdateRenew() {
    let payment_method: string = ""
    if (this.checkBoxFullPay()) {
      let date = new Date(this.insuredetail_data.lastClaimDate)
      let now_str = `${(date.getDate() > 9) ? date.getDate() : `0${date.getDate()}`}/${(date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : `0${(date.getMonth() + 1)}`}/${date.getFullYear()}`
      payment_method = `${this.total_amount()} ${now_str}`
    } else {
      this.installmentData().forEach((list, i) => {
        if (i === 0) {
          this.total_amount.set(list.value);
        } else {
          payment_method += "|"
        }
        let date = new Date(list.date)
        let now_str = `${(date.getDate() > 9) ? date.getDate() : `0${date.getDate()}`}/${(date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : `0${(date.getMonth() + 1)}`}/${date.getFullYear()}`
        payment_method += `${list.value} ${now_str}`
      })
    }

    let body = {
      "input_address": this.insuredetail_data.address,
      "input_mobile_no": this.insuredetail_data.phoneNo,
      "f09_status": this.f09Status,
      "renewMotorUCID": this.dataucid,
      "payment_method": payment_method
    }
    return body;
  }

  /**
   * non motor summary
   */
  async flexSummaryTemplate() {
    this.logger.info('flexSummaryTemplate')
    let refNo = this.insuredetail_data.refNo;
    let resultmasking = await this.getMaskingService.exec({insureNo:this.insuredetail_data.refNo})
    if(resultmasking['response_code'] == "40000" && resultmasking['data']){
      refNo = resultmasking['data'].masking_data[0].mask_value[0];
    }   
    let flex_body = [];
    flex_body.push({ "type": "box", "layout": "horizontal", "contents": [{ "type": "text", "text": "หมายเลขอ้างอิง: " + refNo, "size": "xxs", "align": "start", "weight": "regular", "color": "#ABABAB" }] });
    flex_body.push({ "type": "box", "layout": "horizontal", "contents": [{ "type": "text", "text": "ผลิตภัณฑ์ต่ออายุ", "size": "md", "align": "start", "weight": "bold", "color": "#1c69b1", "style": "normal" }] });

    let summary_protect = 0;
    let old_1_1 = '';
    this.insuredetail_data.main_protection.forEach(async (main_protection, index) => {
      main_protection.forEach(element => {
        if (element.checked === true) {
          let number1_1;
          let number2 = environment.images_url + element.logo;
          let number3 = element.group_name;
          let number4 = element.product_name;
          let number5 = element.plan ? element.plan : '-';
          let number6 = element.premium;

          let date_number7 = new Date(element.due_date);
          let number7 = date_number7.getDate() + " " + this.months[date_number7.getMonth()] + " " + (date_number7.getFullYear() + 543);

          summary_protect += Number(number6);
          if (this.insuredetail_data.product_family_flag == 1) {
            // is single
            number1_1 = null;
          } else if (this.insuredetail_data.product_family_flag == 2) {
            // is family
            number1_1 = element.relationship;
          }

          if (number1_1 != null && old_1_1 != number1_1) {
            old_1_1 = number1_1;
            flex_body.push({ "type": "box", "layout": "horizontal", "contents": [{ "type": "box", "layout": "horizontal", "contents": [{ "type": "text", "size": "18px", "align": "start", "weight": "regular", "color": "#ffffff", "text": old_1_1, "decoration": "none", "style": "normal", "margin": "5px" }] }], "backgroundColor": "#0164a5" });
          }

          let body = [
            { "type": "image", "url": number2, "flex": 1, "align": "start", "gravity": "center", "size": "xs", "aspectRatio": "1:1" },
            // { "type": "separator", "margin": "xs", "color": "#DDDDDD" },
            {
              "type": "box", "layout": "vertical", "flex": 3, "spacing": "none", "margin": "sm",
              "contents": [
                { "type": "box", "layout": "horizontal", "contents": [{ "type": "text", "text": number3, "size": "xxs", "align": "start", "weight": "regular", "color": "#ABABAB" }] },
                { "type": "box", "layout": "horizontal", "contents": [{ "type": "text", "text": number4, "size": "xxs", "align": "start", "weight": "regular", "wrap": true }] },
                {
                  "type": "box", "layout": "horizontal", "flex": 2, "contents": [
                    { "type": "text", "text": number5, "size": "xxs", "align": "start", "weight": "regular", "gravity": "center" },
                    { "type": "text", "text": this.formatNumber(number6) + " บาท", "size": "xxs", "align": "end", "weight": "bold", "color": "#293845" }
                  ]
                },
                { "type": "box", "layout": "horizontal", "contents": [{ "type": "text", "text": "ครบกำหนด " + number7, "size": "xxs", "align": "start", "weight": "bold", "color": "#FF0000" }] },
                { "type": "box", "layout": "vertical", "contents": [{ "type": "separator", "margin": "sm", "color": "#DDDDDD" }], "paddingTop": "7px" },
              ], // "paddingStart": "5px"
            }
          ];

          let main = { "type": "box", "layout": "horizontal", "contents": body };
          flex_body.push(main);
        }
      });

      if (this.insuredetail_data.second_protection[index] && this.insuredetail_data.second_protection[index].length > 0) {
        this.insuredetail_data.second_protection[index].forEach(async (element) => {
          if (element.checked === true) {
            let bgcolor = "#c4e8ff";
            let number2 = environment.images_url + element.logo;
            let number3 = element.group_name;
            let number4 = element.product_name;
            let number5 = element.plan ? element.plan : '-';
            let number6 = element.premium;

            let date_number7 = new Date(element.due_date);
            let number7 = date_number7.getDate() + " " + this.months[date_number7.getMonth()] + " " + (date_number7.getFullYear() + 543);
            summary_protect += Number(number6);

            let body = [
              { "type": "image", "url": number2, "flex": 1, "align": "start", "gravity": "center", "size": "xs", "aspectRatio": "1:1" },
              // { "type": "separator", "margin": "xs", "color": "#DDDDDD" },
              {
                "type": "box", "layout": "vertical", "flex": 3, "spacing": "none", "margin": "sm",
                "contents": [
                  { "type": "box", "layout": "horizontal", "contents": [{ "type": "text", "text": "ผลิตภัณฑ์คุ้มครองเพิ่มเติม", "size": "xxs", "align": "start", "weight": "bold", "color": "#1c69b1" }] },
                  { "type": "box", "layout": "horizontal", "contents": [{ "type": "text", "text": number4, "size": "xxs", "align": "start", "weight": "regular", "wrap": true }] },
                  {
                    "type": "box", "layout": "horizontal", "flex": 2, "contents": [
                      { "type": "text", "text": number5, "size": "xxs", "align": "start", "weight": "regular", "gravity": "center" },
                      { "type": "text", "text": this.formatNumber(number6) + " บาท", "size": "xxs", "align": "end", "weight": "bold", "color": "#293845" }
                    ]
                  },
                  { "type": "box", "layout": "vertical", "contents": [{ "type": "separator", "margin": "sm", "color": "#DDDDDD" }], "paddingTop": "7px" },
                ], // "paddingStart": "5px"
              }
            ];

            let main = { "type": "box", "layout": "horizontal", "contents": body, "backgroundColor": "#FFFFFF" };
            flex_body.push(main);
          }
        });
      }
    });

    let credit_status = null;
    let dis_credit_status = false;
    this.insuredetail_data.main_protection.forEach(async (main_protection, index) => {

      if (credit_status == 0) {
        return true;
      }

      main_protection.forEach(async (element) => {
        if (credit_status == 0) {
          return true;
        }

        if (element.checked === true) {
          if (element.credit_status === null) {
            dis_credit_status = true;
          } else if (element.credit_status == 0) {
            credit_status = element.credit_status;
            dis_credit_status = false;
            return true;
          } else if (element.credit_status == 1) {
            credit_status = element.credit_status;
            dis_credit_status = true;
          }
        }
      });

      if (credit_status == 0) {
        return true;
      }

      if (this.insuredetail_data.second_protection[index] && this.insuredetail_data.second_protection[index].length > 0) {
        this.insuredetail_data.second_protection[index].forEach(async (element) => {
          if (credit_status == 0) {
            return true;
          }

          if (element.checked === true) {
            if (element.credit_status === null) {
              dis_credit_status = true;
            } else if (element.credit_status == 0) {
              credit_status = element.credit_status;
              dis_credit_status = false;
              return true;
            } else if (element.credit_status == 1) {
              credit_status = element.credit_status;
              dis_credit_status = true;
            }
          }
        });
      }
    });

    const flex_header = { "type": "box", "layout": "vertical", "contents": [{ "type": "box", "layout": "vertical", "flex": 0, "contents": [{ "type": "image", "url": "https://myprotection3.talpha.co/contents/images/Header-TISCO-Insure.png", "flex": 0, "margin": "none", "align": "center", "gravity": "top", "size": "full", "aspectRatio": "10:1", "backgroundColor": "#FFFFFF", "aspectMode": "fit" }, { "type": "text", "text": "สรุปรายการที่ท่านเลือก", "position": "absolute", "style": "normal", "size": "18px", "offsetStart": "15px", "color": "#FFFFFF", "offsetTop": "3px" }] }], "paddingAll": "0px" };
    const url_credit = `https://liff.line.me/${this.liff_id}?dataucid=${this.dataucid}&letterucid=null&page=payment-summary&amount=${this.total_amount()}&liffId=${this.liff_id}&product_type=2&credit_status=${credit_status}&subchannel=${this.subChannel}`;
    const url_qrcode = `https://liff.line.me/${this.liff_id}?dataucid=${this.dataucid}&letterucid=null&page=qr-barcode&amount=${this.total_amount()}&liffId=${this.liff_id}&product_type=2&subchannel=${this.subChannel}`;

    let AR_footer = [];
    // AR_footer.push({ "type": "box", "layout": "vertical", "contents": [{ "type": "separator", "margin": "sm", "color": "#DDDDDD" }], "paddingTop": "2px", "paddingBottom": "2px" });
    AR_footer.push({ "type": "box", "layout": "horizontal", "contents": [{ "type": "box", "layout": "vertical", "contents": [{ "type": "box", "layout": "horizontal", "contents": [{ "type": "text", "text": "ค่าเบี้ยประกันภัยทั้งหมด", "size": "xs", "align": "start", "weight": "bold", "color": "#293845" }, { "type": "text", "text": this.formatNumber(summary_protect) + " บาท", "size": "xs", "align": "end", "weight": "bold", "color": "#293845" }], "paddingAll": "2px" }], "flex": 2 }] });
    AR_footer.push({ "type": "box", "layout": "vertical", "contents": [{ "type": "separator", "margin": "sm", "color": "#DDDDDD" }] });
    AR_footer.push({ "type": "text", "text": "ช่องทางการชำระเงิน", "align": "center", "size": "xs", "weight": "bold", "color": "#293845" });
    if (dis_credit_status) {
      AR_footer.push({ "type": "box", "layout": "horizontal", "contents": [{ "type": "button", "action": { "type": "uri", "label": "เครดิต / เดบิต", "uri": url_credit }, "style": "primary", "color": "#0164a5" }], "paddingTop": "2px", "paddingBottom": "2px" });
    }

    AR_footer.push({ "type": "box", "layout": "horizontal", "contents": [{ "type": "button", "action": { "type": "uri", "uri": url_qrcode, "label": "QR Code / BarCode" }, "style": "primary", "color": "#0164a5" }], "paddingTop": "2px", "paddingBottom": "2px" });
    this.logger.debug("flex_body: ", flex_body)
    let carousel =
    {
      "type": "bubble",
      "size": "mega",
      "direction": "ltr",
      "header": flex_header,
      "body": {
        "type": "box",
        "layout": "vertical",
        "margin": "none",
        "contents": flex_body,
        "offsetTop": "0px",
        "paddingTop": "15px",
        "paddingBottom": "0px"
      },
      "footer": { "type": "box", "layout": "vertical", "contents": AR_footer }
    };

    // this.line_id = "Udadc4f8639df4d33a48f95ae5024fb57";
    // this.rm_channelId = "279";

    let final_template = { "type": "flex", "altText": "ข้อมูลกรมธรรม์", "contents": carousel };
    const populateLine = {
      customerId: this.line_id,
      liff_channel_id: this.liff_channel_id,
      channel_line_id: this.channel_line_id,
      channelId: this.rm_channelId,
      message: [{
        type: 8,
        payload: {
          payloadDetail: final_template
        }
      }]
    }

    this.SendLineMessage.exec(populateLine).then(async (res) => {
      liff.closeWindow();
      if (res['status'] === true) {
        this.logger.debug('success')
      } else {
        this.logger.error('fail')
      }
    }).catch((error) => {
      this.logger.error('error sendLineMessageService', error)
    });
  }

  private formatNumber(number) {
    number = number.toFixed(2) + '';
    let x = number.split('.');
    let x1 = x[0];
    let x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
  }
}
